import { isNothing, type Maybe } from "../maybe";
import { isTauri } from "../runtime";
import { isCloudRoot, isDemoRoot } from "./projectRoot";

/** True when the app can persist edits for this root (desktop, cloud, or demo). */
export function canPersistProjectRoot(rootPath: Maybe<string>): boolean {
  if (isNothing(rootPath)) return false;
  const root = rootPath.value;
  if (isCloudRoot(root) || isDemoRoot(root)) return true;
  return isTauri();
}

/** True when the app can read/write project files for this root (desktop disk or cloud). */
export function usesProjectBackend(rootPath: Maybe<string>): boolean {
  return canPersistProjectRoot(rootPath);
}
